/* The design system's ink-stamp line icons, for surfaces built without React.
 *
 * WHY THESE ARE HERE AND NOT IN vendor/. `sync-ds` copies the design system's
 * compiled CSS and fonts into packages/ds/vendor and nothing else: the
 * bundle's JavaScript is React components, and the static site runs no
 * framework. So the fifteen icons the landing page uses were read out of that
 * bundle's source (the shared BASE attributes and each path, verbatim) and are
 * kept here as strings a build script can drop straight into a document.
 *
 * NOT A GENERIC ICON LIBRARY, on the README's instruction. Same 22-unit
 * viewBox, same 1.6 stroke, same round caps and joins as every icon in the
 * apps, so the page and the app read as one product rather than two.
 */
const BASE =
  'viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.6" ' +
  'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';

const PATHS: Record<string, string> = {
  home: '<path d="M3 10.5 11 4l8 6.5"/><path d="M5.5 9v8a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V9"/>',
  card: '<rect x="2.5" y="5.5" width="17" height="11" rx="1.4"/><path d="M2.5 9.5h17"/>',
  chart: '<path d="M4 18V9M11 18V4M18 18v-6"/><path d="M2.5 18h17"/>',
  users:
    '<circle cx="8" cy="8" r="3"/><path d="M2.5 18c0-3 2.5-5 5.5-5s5.5 2 5.5 5"/>' +
    '<circle cx="16" cy="8.5" r="2.4"/><path d="M14.5 13.2c2.6.2 4.5 2 4.5 4.8"/>',
  gear:
    '<circle cx="11" cy="11" r="2.8"/>' +
    '<path d="M11 3.5v2M11 16.5v2M18.5 11h-2M5.5 11h-2M16.4 5.6l-1.4 1.4M7 14.9l-1.4 1.4M16.4 16.4l-1.4-1.4M7 7l-1.4-1.4"/>',
  stamp:
    '<circle cx="11" cy="9" r="4.2"/><path d="M11 4.8v8.4"/><path d="M5 19h12"/>' +
    '<path d="M7.5 19c0-2.2 1.5-3.5 3.5-3.5s3.5 1.3 3.5 3.5"/>',
  gift:
    '<rect x="3.5" y="9" width="15" height="10" rx="1"/><path d="M3.5 12.5h15"/><path d="M11 9v10"/>' +
    '<path d="M11 9C9 9 7.2 7.6 7.2 6.1 7.2 4.9 8.1 4 9.2 4c1.4 0 1.8 2.4 1.8 5Z"/>' +
    '<path d="M11 9c2 0 3.8-1.4 3.8-2.9 0-1.2-.9-2.1-2-2.1-1.4 0-1.8 2.4-1.8 5Z"/>',
  ladder: '<path d="M6 19V3M16 19V3"/><path d="M6 6h10M6 11h10M6 16h10"/>',
  search: '<circle cx="9.5" cy="9.5" r="6"/><path d="M14 14l5 5"/>',
  close: '<path d="M5 5l12 12M17 5 5 17"/>',
  menu: '<path d="M3.5 6h15M3.5 11h15M3.5 16h15"/>',
  bolt: '<path d="M12.5 2.5 5 12.5h5l-1.5 7L17 9.5h-5.5Z"/>',
  chevronLeft: '<path d="M13.5 5 7.5 11l6 6"/>',
  chevronRight: '<path d="M8.5 5 14.5 11l-6 6"/>',
  signOut:
    '<path d="M9 4H5.5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1H9"/><path d="M13.5 15l4-4-4-4"/><path d="M17.3 11h-9.8"/>',
};

export const ICON_NAMES: string[] = Object.keys(PATHS);

/** One icon as an inline SVG string. Throws on an unknown name rather than
 *  rendering nothing: a missing icon that renders as a gap is the kind of
 *  defect a page check does not catch. */
export function iconSvg(name: string, size = 20, className = ""): string {
  const d = PATHS[name];
  if (!d) throw new Error(`no icon named "${name}"; have ${ICON_NAMES.join(", ")}`);
  const cls = className ? ` class="${className}"` : "";
  return `<svg ${BASE} width="${size}" height="${size}"${cls}>${d}</svg>`;
}
